import { Editor } from 'grapesjs';

export const SetDeviceCommand = {
  sender: undefined,
  run(editor: Editor, sender: any, options: any = {}) {
    this.sender = sender;
    editor.setDevice(options.device);
  },

  stop(editor: Editor) {
    const { sender = {} }: { sender: any } = this;
    sender.set && sender.set('active', 0);
  },
};
